exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-icon[data-v-06953bf5]{display:inline-block;height:1.3em;margin:-.3em 0}.btn-icon[data-v-06953bf5]:focus{outline:none}", ""]);

// exports
